import { Component } from '@angular/core';
import { CrustLogoComponent } from '../../svg/crust-logo';

@Component({
	selector: 'app-loading',
	imports: [CrustLogoComponent],
	standalone: true,
	templateUrl: './app-loading.html',
	styleUrl: './app-loading.scss'
})
export class AppLoadingComponent {
}

